import {createAsyncThunk} from "@reduxjs/toolkit";
import {getSSOconfig, updateSSOConfig} from "../api/eua";

// response
// {
//     "uuid": "4ea0d3f5-f7ee-4bce-8103-5c52b61962ad",
//     "isSocialSsoEnabled": false,
//     "isCustomSsoEnabled": true,
//     "shareUserTracking": false,
//     "customSsoSecretKey": "secret key value",
//     "ssoOptions": [
//     "FACEBOOK",
//     "GOOGLE"
// ]
// }
export const fetchAccountSSOconfig = createAsyncThunk(
    'account/fetchAccountSSOconfig',
    async (siteUUID) => {
        const response = await getSSOconfig(siteUUID);
        return response.data
    });


export const updateAccountSSOconfig = createAsyncThunk(
    'account/updateAccountSSOconfig',
    async ({configUUID, requestData}) => {
        // console.log('account/updateAccountSSOconfig')
        const response = await updateSSOConfig(configUUID, requestData);
        return response.data
    });